<template>
  <div
    class="search-app__container"
    :class="{ 'search-app--is-hidden': closeModal == 0 }"
  >
    <div id="search-app">
      <div class="container">
        <SearchBar
          @termChange="onTermChange"
          @onModalClose="onModalClose"
        />

        <template v-if="displaySearchElements">
          <div
            v-if="popularKeyWordsFlag || popularTrendingProductsFlag"
            class="search-app__suggestions"
          >
            <SearchPopularSuggestions :popular-key-words="popularKeyWords" />
            <SearchTrendingCard
              :trending-products="trendingProducts[0]"
              :search-term-="searchTerm"
            />
            <br style="clear: both">
          </div>
          <div
            v-else
            class="search-app__suggestions"
          >
            <SearchPopularSuggestions :popular-key-words="initialPopularKeyWords" />
            <SearchTrendingCard
              :trending-products="initialTrendingProducts[0]"
              :search-term-="searchTerm"
            />
            <br style="clear: both">
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from '~legacy-vue/vueComponents/SearchModal/SearchBar.vue'
import SearchPopularSuggestions from '~legacy-vue/vueComponents/SearchModal/SearchModalPopularSuggestion.vue'
import SearchTrendingCard from '~legacy-vue/vueComponents/SearchModal/SearchModalTrendingCard.vue'


export default {
  name: 'Search',
  delimiters: ['{$', '$}'],

  components: {
    SearchBar,
    SearchPopularSuggestions,
    SearchTrendingCard,
  },

  emits: ['on-search-toggle'],

  data() {
    return {
      searchTerm: 'defaultsearch',
      popularKeyWords: [],
      trendingProducts: [],
      initialPopularKeyWords: [],
      initialTrendingProducts: [],
      closeModal: 0,
      callbackData: {},
      SlickSliderSettings: {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        lazyload: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              dots: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              dots: false,
              arrows: false,
            },
          },
        ],
      },
      popularKeyWordsFlag: false,
      popularTrendingProductsFlag: false,
      fullSearchTerm: '',
      isSearchClicked: false,
      firstLoadedDone: false,
      isSearchOpened: false,
    }
  },

  computed: {
    /**
     * Whether to display search elements based on market restriction and Shopify
     * merchandising fallback flag.
     * - Shows search elements only if both are disabled
     * @returns {boolean}
     */
    displaySearchElements() {
      return Boolean(
        !mint?.search?.enableSearchMarketRestriction &&
          !this.getShopifyMerchandisingFlag()
      );
    },
  },

  watch: {
    popularKeyWords: {
      handler: function (newValue, oldValue) {
        if(newValue.length == 0) {
          this.search('defaultsearch')
        } else if ((newValue != oldValue) && (newValue.length >= 3)){
          this.search(this.searchTerm)
        }
      },
    },
    searchTerm: {
      handler: function (newValue) {
        if(newValue.length >= 3) {
          this.searchTerm = newValue
          this.search(this.searchTerm)
        }
      },
    },
    trendingProducts: {
      deep: true,
      handler: function (newValue, oldValue) {
        if (newValue[0].length > 0) {
          this.popularTrendingProductsFlag = true
        } else {
          this.popularTrendingProductsFlag = false
        }
      },
    },
    popularKeyWords: {
      deep: true,
      handler: function (newValue, oldValue) {
        if (newValue.length && newValue[0].length > 0) {
          this.popularKeyWordsFlag = true
        } else {
          this.popularKeyWordsFlag = false
        }
      },
    },

    isSearchClicked: {
      deep: true,
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.search(this.searchTerm)

        }
      },
    },

  },

  beforeUpdate() {
    if ($('.search-app__cards').hasClass('slick-initialized')) {
      $('.search-app__cards').slick('unslick')
    }
  },

  updated() {
    $('.search-app__cards').slick(this.SlickSliderSettings)
  },

  mounted() {
    const that = this
    window.searchCallback = function (jsonResponse) {
      const responseAsObject = eval(jsonResponse)
      that.callbackData = responseAsObject
      that.feedData(that.callbackData)
      const jsonpScript = document.getElementById('jsonpScript')
      jsonpScript.parentNode.removeChild(jsonpScript)

    }
    this.toggleModal()

    const searchIconSelectors = ['.search-app__trigger', '.item__mobile--searchMobile']
    searchIconSelectors.forEach((selector)=> {
      document.querySelector(selector)?.addEventListener('click', () => {
        this.isSearchClicked = true
      })
    })

    mint.EventBus.on('cartDrawer:open', () => {
      if (!this.isSearchOpened) {
        return
      }

      this.onModalClose(0)
    })
  },

  methods: {
    onModalClose: function (child) {
      this.closeModal = child
      document.documentElement.classList.remove('stop-scroll-html')
      document.body.classList.remove('stop-scroll')

      this.isSearchOpened = false
      this.$emit('on-search-toggle', this.isSearchOpened)
    },

    toggleModal: function () {
      document.body.addEventListener('click', (event) => {
        const searchTrigger = event.target.closest('.search-app__trigger')

        if (!searchTrigger) {
          return
        }

        this.closeModal = this.closeModal + 1
        const searchOverlay = event.target.closest('.site-header')?.querySelector('.search-app__container')
        this.isSearchOpened = true

        if (searchOverlay) {
          searchOverlay.classList.toggle('search-app--is-hidden')

          !searchOverlay.classList.contains('search-app--is-hidden') ? searchOverlay.querySelector('.search-app__input')?.focus({ preventScroll: true }) : ''

          this.isSearchOpened = Boolean(!searchOverlay.classList.contains('search-app--is-hidden'))
        }

        mint.EventBus.dispatch('cartDrawer:close')
        this.slickActions('reinit')
        document.documentElement.classList.toggle('stop-scroll-html')
        document.body.classList.toggle('stop-scroll')
        this.$emit('on-search-toggle', this.isSearchOpened)
      })
    },

    search: function (term) {
      if (!this.displaySearchElements) {
        return
      }

      const jsonpScript = document.createElement('script')
      const env = mint.services.attraqt.instance

      jsonpScript.id = 'jsonpScript'
      jsonpScript.src =
        `https://query.published.${env}.suggest.eu1.fredhopperservices.com/mint_velvet/jscript?scope=//mintvelvet/en_GB&callback=searchCallback&search=` +
        term
      document.getElementsByTagName('head')[0].appendChild(jsonpScript)
    },

    setDataByTerm: function (data, container, filter) {
      data.suggestionGroups.forEach((suggestion) => {
        if (suggestion.indexName.includes(filter)) {
          container.push(suggestion.suggestions)
          return
        }
      })
    },

    onTermChange: function (searchTerm) {
      if (!this.displaySearchElements) {
        return
      }

      this.searchTerm = searchTerm
      const term = searchTerm.replace(/\s/g, '')

      if (term.length == 0) {
        // this.loadSearchSuggestions('reinit', 'defaultsearch');
        this.search('defaultsearch')
        return
      }

      if (term.length >= 3) {
        this.search(this.searchTerm)
      }
    },

    slickActions: function (action) {
      switch (action) {
      case 'reinit':
        if ($('.search-app__cards').hasClass('slick-initialized')) {
          $('.search-app__cards').slick('unslick')
        }
        $('.search-app__cards').slick(this.SlickSliderSettings)
        break
      case 'init':
        $('.search-app__cards').slick(this.SlickSliderSettings)
        break
      }
    },

    feedData: function (dataObject) {
      const that = this
      const popularKeyWordsNew = []
      const trendingProductsNew = []
      this.firstLoadedDone = true
      dataObject.suggestionGroups.forEach((suggestion) => {
        if (suggestion.indexName.includes('popularkeywords')) {
          if (that.popularKeyWords.length > 0) {
            that.popularKeyWords = []
          }
          popularKeyWordsNew.push(suggestion.suggestions)
        } else if (suggestion.indexName.includes('products')) {
          if (that.trendingProducts.length > 0) {
            that.trendingProducts = []
          }
          trendingProductsNew.push(suggestion.suggestions)
        }
        this.popularKeyWords = popularKeyWordsNew
        this.trendingProducts = trendingProductsNew

        if (this.initialPopularKeyWords.length == 0) {
          this.initialPopularKeyWords = popularKeyWordsNew
        }
        if (this.initialTrendingProducts.length == 0) {
          this.initialTrendingProducts = trendingProductsNew
        }
      })
    },

    /**
     * Return the state of the Shopify merchandising feature flag.
     * @returns {Boolean}
     */
    getShopifyMerchandisingFlag() {
      return mint?.flags?.shopifyMerchandising?.enable || false
    },
  },
}
</script>